import React from "react";
import { PageContainer } from "../../globals/components/containers";
import { LinkButton } from "../../globals/components/button";
import styled from "styled-components";
import background from "./assets/background.png";
import { Scale } from 'react-scaling';
import meetemile from "./assets/meetemile.png";
import meetaimee from "./assets/meetaimee.png";
import meetscrambler from "./assets/meetscrambler.png";

const MeetEmileContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  align-items: center;
  height: 100%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;
  width: 100%;

  h1 {
    color: #673c8c;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 3em;
  }
`;

const Centered = styled.div`
 
`;

const MiddleText = styled.div`
 width: 55%;
 margin: auto;
 font-size: 2.5em;
 color: #673c8c;
`;

export default function MeetEmile() {
  return (
    <MeetEmileContainer>
      <Scale scaleTo={1920}>
        <MiddleText>
        <Image src={meetemile}></Image>
        <span>
        <b>Emile</b> was just a normal alien, living happily on his peaceful planet, <b>Mathedonia</b>, until <b>Scrambler</b> came and stole all the <b>knowledge gems!</b> Help Aimee and Emile use teamwork to complete challenges and recover all the gems!
        </span>
        <br/>
        <Image src={meetaimee}></Image>
        <span>
        <b>Aimee</b> is <b>Emile’s</b> robotic companion who travels with him on his adventures. She is well versed in mathematics and assists <b>Emile</b> in his mission.
        </span>
        <br/>
        <Image src={meetscrambler}></Image>
        <span>
        <b>Scrambler</b> is a dinosaur alien who lived on the planet called <b>Primus</b>. One day he stole all the <b>knowledge gems</b> and scattered them across the universe.
        </span>
        <br/><br/>
        </MiddleText>
        <div>
          <h1 style={{ textAlign: "center" }}>To continue Emile's story, please download the app.</h1>

          <LinkButton href={process.env.REACT_APP_DOWNLOAD_URL} target="_blank">
            Download App
        </LinkButton>
        </div>
      </Scale>
    </MeetEmileContainer>
  );
}

const Image = styled.img`
width:5%;
height:auto;
`

const Gallery = styled.div`
padding: 0 6px;
  float: left;
  width: 24%;
`
